/* Traversine: allinea la scheda prodotto all'offerta Pumper selezionata.
   - Offerta con 2+ traversine: nasconde (non elimina) i selettori Taglia/Colore del tema
     e mostra una nota, perche' taglia e colore si scelgono riga per riga nell'offerta.
   - Offerta da 1: i selettori del tema restano visibili (Pumper li segue gia').
   - Il prezzo grande e quello della barra fissa mostrano il prezzo dell'offerta selezionata.
   Se Pumper non e' presente o cambia struttura, la pagina resta com'era. */
(function () {
  'use strict';
  if (window.__tlBundleSync) return;
  window.__tlBundleSync = true;

  var CSS = '' +
    '.tl-bundle-multi [data-tl-option]{display:none!important}' +
    '.tl-bundle-note{margin:4px 0 14px;padding:10px 14px;border-radius:12px;background:var(--tl-mist,#eaf5fb);color:var(--tl-ink,#1d2a4d);font-size:14px;line-height:1.45}' +
    '.tl-bundle-note[hidden]{display:none!important}';

  function addStyle() {
    if (document.getElementById('tl-bundle-sync-css')) return;
    var s = document.createElement('style');
    s.id = 'tl-bundle-sync-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function clean(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function toNumber(t) {
    var m = (t || '').replace(/[^\d,.]/g, '');
    if (!m) return NaN;
    if (m.indexOf(',') > -1) m = m.replace(/\./g, '').replace(',', '.');
    return parseFloat(m);
  }

  function init(root) {
    var form = root.querySelector('form[data-tl-form]');
    var firstOption = root.querySelector('[data-tl-option]');
    if (!form || !firstOption) return;
    addStyle();

    var note = document.createElement('p');
    note.className = 'tl-bundle-note';
    note.setAttribute('role', 'note');
    note.hidden = true;
    note.textContent = window.tlBundleNote ||
      "Scegli taglia e colore di ogni traversina nell'offerta qui sopra.";
    firstOption.parentNode.insertBefore(note, firstOption);

    var prices = root.querySelectorAll('[data-tl-price]');
    var was = root.querySelector('[data-tl-compare]');
    var save = root.querySelector('[data-tl-save]');
    var bundle = null;
    var queued = false;
    var driven = false;

    var product = null;
    try { product = JSON.parse(root.querySelector('[data-tl-product-json]').textContent); } catch (e) {}
    var btn = root.querySelector('[data-tl-add]');

    /* Con i selettori nascosti il cliente non potrebbe uscire da una variante esaurita
       scelta prima: in quel caso si passa alla stessa taglia in un colore disponibile
       (o alla prima variante disponibile). Restituisce true se ha cambiato variante. */
    function fixUnavailable() {
      if (!product || !btn || !btn.disabled) return false;
      var fieldsets = root.querySelectorAll('[data-tl-option]');
      var current = Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
      var avail = product.variants.filter(function (v) { return v.available; });
      if (!avail.length) return false;
      var target = avail.find(function (v) { return v.options[0] === current[0]; }) || avail[0];
      var changed = null;
      fieldsets.forEach(function (fs, i) {
        var input = Array.prototype.find.call(fs.querySelectorAll('input'), function (x) { return x.value === target.options[i]; });
        if (input && !input.checked) { input.checked = true; changed = input; }
      });
      if (!changed) return false;
      changed.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    function apply() {
      queued = false;
      bundle = bundle && document.contains(bundle) ? bundle : document.getElementById('pumper_bundle_svelte');
      var card = bundle && bundle.querySelector('.pmpr-tier-shell__card[data-selected="true"]');
      if (!card) {
        /* Nessuna offerta selezionata (il cliente ha ricliccato quella attiva):
           si torna alla scheda normale, con il prezzo della variante scelta. */
        form.classList.remove('tl-bundle-multi');
        note.hidden = true;
        if (driven) {
          driven = false;
          var checked = form.querySelector('[data-tl-option] input:checked');
          if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      var multi = card.querySelectorAll('.pumper_variant_row').length > 1;
      form.classList.toggle('tl-bundle-multi', multi);
      note.hidden = !multi;
      if (multi && fixUnavailable()) return; /* riparte da solo dopo il cambio variante */

      var total = clean(card.querySelector('.pmpr-tier-price__total'));
      var compare = clean(card.querySelector('.pmpr-tier-price__compare'));
      var tn = toNumber(total), cn = toNumber(compare);
      if (!total || isNaN(tn)) return;
      driven = true;
      prices.forEach(function (p) { if (p.textContent !== total) p.textContent = total; });
      var hasCompare = !isNaN(cn) && cn > tn;
      if (was) {
        was.hidden = !hasCompare;
        if (hasCompare && was.textContent !== compare) was.textContent = compare;
      }
      /* Il risparmio lo mostra gia' l'offerta (con il suo calcolo): qui lo nascondiamo
         per non avere due cifre diverse sulla stessa pagina. */
      if (save) save.hidden = true;
    }

    function schedule() {
      if (queued) return;
      queued = true;
      (window.requestAnimationFrame || setTimeout)(function () { setTimeout(apply, 0); });
    }

    var observer = new MutationObserver(schedule);
    function watch(el) {
      observer.observe(el, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-selected'] });
    }

    var tries = 0;
    (function find() {
      bundle = document.getElementById('pumper_bundle_svelte');
      if (bundle) { watch(bundle); schedule(); return; }
      if (++tries < 60) setTimeout(find, 250);
    })();

    document.addEventListener('tl:variant', schedule);
  }

  function boot() {
    document.querySelectorAll('[data-tl-product]:not([data-tl-bundle-ready])').forEach(function (r) {
      r.setAttribute('data-tl-bundle-ready', '1');
      init(r);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
